import * as React from 'react'
import bind from 'bind-decorator'

export type FieldProps = {
    letter: string
    isMissing: boolean
    className?: string
}

export type MethodProps = {
    navigateTo: (letter: string) => void
}

export type Props = FieldProps & MethodProps

class NavigationLetter extends React.Component<Props> {
    @bind
    navigateTo(e: React.MouseEvent) {
        if (!this.props.isMissing) {
            e.preventDefault()
            this.props.navigateTo(this.props.letter)
        }
    }

    render() {
        const { letter, isMissing, className = '' } = this.props
        const brandClass = 'brand-navigation__item'

        return (
            <li
                className={`${brandClass} ${isMissing ? `${brandClass}--is-missing` : ''} ${className}`}
                onClick={this.navigateTo}
            >
                {letter}
            </li>
        )
    }
}

export default NavigationLetter
